export const { colorBlack, colorBlue, colorWhite, colorGray8 } = {
  colorBlack: '#000000',
  colorBlue: '#0a84ff',
  colorWhite: '#ffffff',
  colorGray8: '#8c8c8c',
};
